import React, { useEffect, useState } from "react";
import NotificationPopup from "../Popup/NotificationPopup";
import { localstorage } from "../../Helpers/localstorage";
import moment from "moment";
import Button from "../Button";
export var Promo = function () {
    var _a = localstorage("promotion-dismissed"), get = _a.get, set = _a.set;
    var cookie = window.cookie.get();
    var query = new URLSearchParams(window.location.search);
    var isPromoTarget = query.get("utm_campaign") == "promobanner";
    var _b = (reactConfig === null || reactConfig === void 0 ? void 0 : reactConfig.promotionalPopup) || {}, heading = _b.heading, description = _b.description, emoji = _b.emoji, expiry = _b.expiry, _c = _b.not_for_stores, notForStores = _c === void 0 ? [] : _c, button = _b.button, link = _b.link;
    var popupAvailable = (!!heading || !!description) &&
        moment(expiry, "DD/MM/YYYY").isAfter(moment());
    var showForLocation = (notForStores === null || notForStores === void 0 ? void 0 : notForStores.length) == 0 ||
        (cookie.area &&
            cookie.area.store_id &&
            !notForStores.includes(cookie.area.store_id.toString()));
    var newPopup = get() == null || get() != expiry;
    var showPopup = popupAvailable && newPopup && showForLocation && !isPromoTarget;
    var _d = useState(showPopup), open = _d[0], setOpen = _d[1];
    useEffect(function () {
        if (isPromoTarget) {
            set(expiry);
        }
    }, []);
    return (React.createElement("div", null,
        React.createElement(NotificationPopup, { open: open, onClose: function () {
                set(expiry);
                setOpen(false);
            }, closeInSeconds: 0 },
            React.createElement("div", { className: "promo-container" },
                React.createElement("span", { className: "promo-icon-full" }, emoji),
                React.createElement("div", { className: "promo-body" },
                    React.createElement("div", { className: "promo-body-title" },
                        React.createElement("div", { className: "promo-body-title-icon" }, emoji),
                        React.createElement("strong", null, heading)),
                    React.createElement("p", { className: "promo-body-content" }, description)),
                !!button && !!link && (React.createElement(Button, { label: button, href: "".concat(link, "?utm_campaign=promobanner") }))))));
};
